export class MonthlyPlan {
    id!: string
    date!: Date
    revenue!: number
    profit!: number
}
